module.exports = __webpack_public_path__ + "img/fullscreen.6af6bc2a.svg";